import { useContext } from 'react';
import { UseUserTokenContext } from './user-token-context';
export const useUserToken = () => {
  const context = useContext(UseUserTokenContext);
  if (context === undefined) {
    throw new Error('useUserToken must be used within a UserTokenProvider');
  }
  return context;
};